const awsConfig = {
  aws_project_region: process.env.GATSBY_AWS_PROJECT_REGION,
  aws_cognito_identity_pool_id: process.env
    .GATSBY_AWS_SURVEY_COGNITO_IDENTITY_POOL_ID as string,
  aws_cognito_region: process.env.GATSBY_AWS_COGNITO_REGION as string,
  aws_cloud_logic_custom: [
    {
      name: "surveyApi",
      endpoint: process.env.GATSBY_AWS_SURVEY_GRAPHQLENDPOINT as string,
      region: process.env.GATSBY_AWS_PROJECT_REGION as string,
    },
  ],
};

export default awsConfig;
